import { ISelectOption, TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import { ECondition, EReward } from './interfaces';

export const getConditionOptions = (
  t: TTranslator<TLocalesKeys>
): Array<ISelectOption<ECondition>> => [
  {
    title: t('achievements.condition.spentHours'),
    value: ECondition.SpentHours,
  },
  {
    title: t('achievements.condition.spentSumOnce'),
    value: ECondition.SpentSumOnce,
  },
  {
    title: t('achievements.condition.spentSumOverall'),
    value: ECondition.SpentSumOverall,
  },
  {
    title: t('achievements.condition.addDepositOnce'),
    value: ECondition.AddDepositOnce,
  },
  {
    title: t('achievements.condition.addDepositOverall'),
    value: ECondition.AddDepositOverall,
  },
  {
    title: t('achievements.condition.register'),
    value: ECondition.Register,
  },
  {
    title: t('achievements.condition.clubComment'),
    value: ECondition.ClubComment,
  },
  {
    title: t('achievements.condition.onlineBooking'),
    value: ECondition.OnlineBooking,
  },
];

export const getRewardOptions = (
  t: TTranslator<TLocalesKeys>
): Array<ISelectOption<EReward>> => [
  { title: t('achievements.reward.discount'), value: EReward.AddDiscount },
  { title: t('achievements.reward.bonus'), value: EReward.AddDeposit },
  { title: t('achievements.reward.none'), value: EReward.None },
];
